import React from 'react'
import { PageHeader, Tabs, Badge } from 'antd'
import { CloudDownloadOutlined, DeliveredProcedureOutlined, CloseCircleOutlined, CheckCircleOutlined } from '@ant-design/icons';
import IncomingLetters from './IncomingLetters';
import ProcessedLetters from './ProcessedLetters';
import FinishedLetters from './FinishedLetters';
import RejectedLetters from './RejectedLetters';

class RequstedLetters extends React.Component {

    state = {
        total: {
            incoming: 0,
            processed: 0,          
        },
        tabKey: "1"
    }
    componentDidMount() {
        const { state } = this.props.location           
        if(state && state.tabKey){              
            this.props.history.replace({ ...this.props.location.pathname, state: null })
            this.setState({ tabKey: state.tabKey })
        }
    }

    countLetters = (countData, type) => {
        let { total } = this.state
        total[type] = countData
        this.setState({ total })
    }

    changeTab = (key) => {
        this.setState({ tabKey: key })
    }

    render() {        
        return(
            <>
            <div className="site-layout-background" style={{ padding: 10, minHeight: 360 }}>
                <PageHeader
                    className="site-page-header"
                    onBack={() => null}
                    backIcon={null}
                    title="Permohonan Surat"
                    subTitle="daftar permohonan surat"
                />
                <Tabs defaultActiveKey="1" activeKey={this.state.tabKey} onChange={this.changeTab} type="card">
                    <Tabs.TabPane
                     key="1"
                     tab={
                        <Badge count={this.state.total.incoming}>
                        <span style={{paddingRight:15}}>
                          <CloudDownloadOutlined />
                          Permohonan Masuk
                        </span>
                        </Badge>
                      }
                    >
                        <IncomingLetters {...this.props} countLetters={this.countLetters} />
                    </Tabs.TabPane>
                    <Tabs.TabPane
                         key="2"
                         tab={
                            <span>
                              <DeliveredProcedureOutlined />
                              Diproses
                            </span>
                          }
                     >
                        <ProcessedLetters {...this.props} />                  
                    </Tabs.TabPane>
                    <Tabs.TabPane 
                        tab={
                            <span>
                              <CheckCircleOutlined />
                              Selesai Dibuat
                            </span>
                          }
                        key="3"
                    >
                        <FinishedLetters {...this.props} />                    
                    </Tabs.TabPane>
                    <Tabs.TabPane 
                        tab={
                            <span>
                            <CloseCircleOutlined />
                            Ditolak
                            </span>
                        }
                        key="4"
                    >
                        <RejectedLetters {...this.props} />                   
                    </Tabs.TabPane>
                </Tabs>                
            </div>                
        </>
        )
    }
}

export default RequstedLetters